import { createActionName } from "redux/utility"

export const reducerName = "smartrecruiters"

export const SMART_RECRUITERS = createActionName(
    reducerName,
    "SMART_RECRUITERS",
)
